import { EventEmitter } from '@angular/core';

export class EmitterService {

  changeEvent: EventEmitter<any> = new EventEmitter();
  PopupEvent: EventEmitter<any> = new EventEmitter();
  dialogBlockEvent: EventEmitter<any> = new EventEmitter();
  BlockEvent: EventEmitter<any> = new EventEmitter();
  DateEvent: EventEmitter<any> = new EventEmitter();
  CalimEvent: EventEmitter<any> = new EventEmitter();
  DetailsEvent: EventEmitter<any> = new EventEmitter();
  conditionEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  DetailsEventEvent(data) {
    this.DetailsEvent.emit(data);
  }

  getDetailsEventEmitter() {
    return this.DetailsEvent;
  }

  emitChangeEvent(data) {
    this.changeEvent.emit(data);
  }

  getChangeEmitter() {
    return this.changeEvent;
  }
  emitPopupEvent(data) {
    this.PopupEvent.emit(data);
  }
  getPopupEmitter() {
    return this.PopupEvent;
  }

  emitDialogBlock(data) {
    return  this.dialogBlockEvent.emit(data);
  }
  getDialogBlock() {
    return  this.dialogBlockEvent;
  }
  emithBlock(data) {
    return  this.BlockEvent.emit(data);
  }
  refreshBlock() {
    return  this.BlockEvent;
  }
  emithDate(data) {
    return  this.DateEvent.emit(data);
  }
  refreshDataWithDate() {
    return  this.DateEvent;
  }
  /*Réclamation*/
  emitCalim(data) {
    return this.CalimEvent.emit(data);
  }
  getCalim() {
    return this.CalimEvent;
  }
  /*Condition*/
  emitCondition(data) {
    return this.conditionEvent.emit(data);
  }
  getCondition() {
    return this.conditionEvent;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/EmitterService.ts